const backForwardControlsVariants = {
    pagination: {
        $extendFromVariant: "default",
        root: {
            display: "flex",
            marginTop: "$s2",
            marginBottom: "$s2",
            textAlign: "center",
        },
        back: {
            cursor: "pointer",
        },
        forward: {
            cursor: "pointer",
        }
    }
};
export { backForwardControlsVariants };
//# sourceMappingURL=backForwardControls.js.map